import React from "react"
import Edit from "../../../assets/images/editinput.svg"
import {Select} from "@appkit4/react-components/select"
import NewDateString from '../../../components/Common/newDateString.js'
import PropTypes from "prop-types";

function AssessmentPlan(props) {
    const getStandardDate = (date) => {
        let newDate = new Date(date);
        let isoDate = newDate.toISOString();
        let requiredDate = isoDate.split("T")[0];
        return requiredDate;
      };
    let { values, touched, errors, handleChange, handleBlur, getAssessorMail, getManagerMail,getAssessment,role } = props;
    let disabledFields;
    if (role === "manager"){
        disabledFields=true
    }
    else{
        disabledFields=false
    }

    return (
        <div >
            <div className="row m-0">
                <div className="col-sm-6">
                    <div className={disabledFields ? "cv-input-field-container-disabled" : "cv-input-field-container"}>
                        <label className="cv-input-label">
                        Third Party Name  <span className="asterisk-required">*</span>
                        </label>
                        <Select
                            showSearchOnToggle={true}
                            dropdownRenderMode="portal"
                            searchable={true}
                            className="cv-input-field"
                            value={values.vendorname}
                            data={props.vendors}
                            valueKey="vendor_id"
                            labelKey="vendor_name"
                            onSelect={(e) => handleChange("vendorname")({ target: { value: e } })}
                            name="department"
                            placeholder="Select Third Party Name"
                            disabled={disabledFields}
                        >
                        </Select>                
                    </div>
                    {errors.vendorname && touched.vendorname && (
                        <div className="form-label error">
                            {errors.vendorname}
                        </div>
                    )}
                </div>
                <div className="col-sm-6">
                    <div className={disabledFields ? "cv-input-field-container-disabled" : "cv-input-field-container"}>
                        <label className="cv-input-label">
                                         Criticality <span className="asterisk-required">*</span>
                        </label>
                        <Select
                            showSearchOnToggle={true}
                            dropdownRenderMode="portal"
                            searchable={true}
                            className="cv-input-field"
                            onSelect={(e) => handleChange("assessmentCriticality")({ target: { value: e } })}
                            name="assessmentCriticality"
                            value={values.assessmentCriticality}
                            data={props.criticality}
                            valueKey="criticality_id"
                            labelKey="criticality"
                            placeholder="Please select Criticality"
                            disabled={disabledFields}
                        >
                        </Select>
                    </div>
                    {errors.assessmentCriticality && touched.assessmentCriticality && (
                        <div className="form-label error">{errors.assessmentCriticality}</div>
                    )}
                </div>
            </div>
            <div className="row m-0">
                <div className="col-sm-6">
                    <div className={disabledFields ? "cv-input-field-container-disabled" : "cv-input-field-container"}>
                        <label className="cv-input-label">
                            Frequency  
                            </label> 
                        <Select
                            showSearchOnToggle={true}
                            dropdownRenderMode="portal"
                            searchable={true}
                            className="cv-input-field"
                            type="email"
                            value={values.planFrequency}
                            onSelect={(e) => handleChange("planFrequency")({ target: { value: e } })}
                            name="frequency"
                            data={props.frequency}
                            labelKey="frequency"
                            valueKey="frequency_id"
                            placeholder="Please select frequency"
                            disabled={disabledFields}
                        >
                        </Select>
                    </div>
                   
                </div>
                <div className="col-sm-6">
                    <div className={disabledFields ? "cv-input-field-container-disabled" : "cv-input-field-container"}>
                        <label className="cv-input-label">
                            Recurrence Month (s) 
                        </label>
                        <Select
                            showSearchOnToggle={true}
                            dropdownRenderMode="portal"
                            searchable={true}
                            className="cv-input-field"
                            type="number"
                            value={values.recurrenceMonth}
                            onSelect={(e) => handleChange("recurrenceMonth")({ target: { value: e } })}
                            name="recurrence"
                            data={props.recurrence}
                            valueKey="recurrence_id"
                            labelKey="recurrence"
                            placeholder="Please select recurrence month"
                            disabled={disabledFields}
                        >

                        </Select>
                    </div>
                   
                </div>
            </div>
            <div className="row m-0">
                <div className="col-sm-6">
                    <div className={disabledFields ? "cv-input-field-container-disabled" : "cv-input-field-container"}>
                        <label htmlFor="totalAssessmentPlan" className="cv-input-label">
                            Total Assessment<span className="asterisk-required">*</span> 
                        </label>
                        <input
                            className={disabledFields ? "cv-input-field-disabled leftPadding" :"cv-input-field leftPadding"}
                            onBlur={handleBlur}
                            type="tel"
                            id="totalAssessmentPlan"
                            value={values.totalAssessment}
                            onChange={handleChange("totalAssessment")}
                            name="TotalAssessment"
                            disabled={disabledFields}
                        />
                        <img alt="edit" src={Edit} className="edit-input" />
                    </div>
                    {errors.totalAssessment && touched.totalAssessment && (
                        <div className="form-label error">
                            {errors.totalAssessment}
                        </div>
                    )}
                </div>
                <div className="col-sm-6">
                    <div className={disabledFields ? "cv-input-field-container-disabled" : "cv-input-field-container"}>
                        <label htmlFor="completedAssessmentPlan" className="cv-input-label">
                            Completed   <span className="asterisk-required">*</span>
                        </label>
                        <input
                            className={disabledFields ? "cv-input-field-disabled leftPadding" :"cv-input-field leftPadding"}
                            onBlur={handleBlur}
                            id="completedAssessmentPlan"
                            type="tel"
                            value={values.completed}
                            onChange={handleChange("completed")}
                            name="Completed"
                            disabled={disabledFields}
                        />
                        <img alt="edit" src={Edit} className="edit-input" />
                    </div>
                    {errors.completed && touched.completed && (
                        <div className="form-label error">
                            {errors.completed}
                        </div>
                    )}
                </div>
            </div>
            <div className="row m-0">
                <div className="col-sm-6">
                    <div className={disabledFields ? "cv-input-field-container-disabled" : "cv-input-field-container"}>
                        <label htmlFor="nextPlannedDateAssessmentPlan" className="cv-input-label">
                            Next Planned Date <span className="asterisk-required">*</span> 
                    </label>
                        <input
                            className={disabledFields ? "cv-input-field-disabled pl-2" :"cv-input-field pl-2"}
                            type="date"
                            name="NextPlannedDate"
                            onBlur={handleBlur}
                            id="nextPlannedDateAssessmentPlan"
                            min={NewDateString()}
                            value={values.nextPlannedDate}
                            onChange={handleChange("nextPlannedDate")}
                            disabled={disabledFields}
                        />
                    </div>
                    {errors.nextPlannedDate && touched.nextPlannedDate && (
                        <div className="form-label error">
                            {errors.nextPlannedDate}
                        </div>
                    )}
                </div>

                <div className="col-sm-6">
                    <div className={disabledFields ? "cv-input-field-container-disabled" : "cv-input-field-container"}>
                        <label htmlFor="lastAssessmentDateAssessmentPlan" className="cv-input-label">
                            Last Assessment Date  
                    </label>
                        <input
                            className={disabledFields ? "cv-input-field-disabled pl-2" :"cv-input-field pl-2"}
                            type="date"
                            name="LastAssessmentDate"
                            onBlur={handleBlur}
                            id="lastAssessmentDateAssessmentPlan"
                            max={NewDateString()}
                            value={values.lastAssessmentDate === "NaN-NaN-NaN" ? "" : values.lastAssessmentDate}
                            onChange={handleChange("lastAssessmentDate")}
                            disabled={disabledFields}
                        />
                    </div>
                    {errors.lastAssessmentDate && touched.lastAssessmentDate && (
                        <div className="form-label error">
                            {errors.lastAssessmentDate}
                        </div>
                    )}
                </div>

            </div>
            <div className="row m-0">
                <div className="col-sm-6">
                    <div className={disabledFields ? "cv-input-field-container-disabled" : "cv-input-field-container"}>
                        <label className="cv-input-label">
                            Information Classification <span className="asterisk-required">*</span>
                        </label>

                        <Select
                            showSearchOnToggle={true}
                            dropdownRenderMode="portal"
                            searchable={true}
                            className="cv-input-field"
                            type="email"
                            value={values.informationClassification}
                            onSelect={(e) => handleChange("informationClassification")({ target: { value: e } })}
                            name="assessment"
                            data={props.Classification}
                            valueKey="informationclassification_id"
                            labelKey="informationclassification_name"
                            placeholder="Select Information Classification"
                            disabled={disabledFields}
                        >
                        </Select>
                    </div>
                    {errors.informationClassification && touched.informationClassification && (
                        <div className="form-label error">
                            {errors.informationClassification}
                        </div>
                    )}
                </div>

                <div className="col-sm-6">
                    <div className={disabledFields ? "cv-input-field-container-disabled" : "cv-input-field-container"}>
                    <label className="cv-input-label"> 
                         Assessment Type <span className="asterisk-required">*</span>
                        </label>
                        <Select
                            showSearchOnToggle={true}
                            dropdownRenderMode="portal"
                            searchable={true}
                            className="cv-input-field"
                            type="email"
                            value={values.assessmentType}
                            data={props.assessmentTypes}
                            valueKey="assessmenttype_id"
                            labelKey="assessment_type"
                            onSelect={(e) => { handleChange("assessmentType")({ target: { value: e } });  getAssessment(e) }}
                            name="assessment"
                            placeholder="Select Assessment"
                            disabled={disabledFields}
                        >
                        </Select>
                    </div>
                    {errors.assessmentType && touched.assessmentType && (
                        <div className="form-label error">
                            {errors.assessmentType}
                        </div>
                    )}
                </div>
            </div>
            <div className="row m-0">

                <div className="col-sm-6">
                    <div className={disabledFields ? "cv-input-field-container-disabled" : "cv-input-field-container"}>
                        <label className="cv-input-label">
                            Assessor   <span className="asterisk-required">*</span>
                        </label>
                        <Select
                            showSearchOnToggle={true}
                            dropdownRenderMode="portal"
                            searchable={true}
                            className="cv-input-field"
                            type="email"
                            value={values.assessor}
                            onSelect={(e) => { handleChange("assessor")({ target: { value: e } }); getAssessorMail(e) }}
                            name="assessment"
                            data={props.Assessors}
                            labelKey="user_name"
                            valueKey="user_id"
                            placeholder="Select Assessor"
                            disabled={disabledFields}
                        >
                        </Select>
                    </div>
                    {errors.assessor && touched.assessor && (
                        <div className="form-label error">
                            {errors.assessor}
                        </div>
                    )}
                </div>
                <div className="col-sm-6">
                    <div className={disabledFields ? "cv-input-field-container-disabled" : "cv-input-field-container"}>
                        <label className="cv-input-label">
                            Manager  <span className="asterisk-required">*</span>
                        </label>
                        <Select
                            showSearchOnToggle={true}
                            dropdownRenderMode="portal"
                            searchable={true}
                            className="cv-input-field"
                            type="email"
                            value={values.manager}
                            onSelect={(e) => { handleChange("manager")({ target: { value: e } }); getManagerMail(e) }}
                            name="assessment"
                            placeholder="Select Manager"
                            data={props.Managers}
                            valueKey="user_id"
                            labelKey="user_name"
                            disabled={disabledFields}
                        >
                        </Select>
                    </div>
                    {errors.manager && touched.manager && (
                        <div className="form-label error">
                            {errors.manager}
                        </div>
                    )}
                </div>
            </div>
            {role === "analyst" ? (
                <div className="row m-0">

                <div className="col-sm-6">
                    <div className="cv-input-field-container-disabled">
                        <label className="cv-input-label">
                            Manager Comments<span className="asterisk-required">*</span>
                        </label>
                        <input
                        className="cv-input-field-disabled"
                        type="text"
                        value={values.managerComments !== null ? values.managerComments : ""}
                        name="comments" placeholder="No comments to show"
                        disabled={true}
                        />
                    </div>
                </div>
                <div className="col-sm-6">
          <div className={ "cv-input-field-container-disabled"}>
            <label htmlFor="EndAfterPlan" className="cv-input-label">
              End After
            </label>
            <input
              className="cv-input-field p-l-2"
              id="EndAfterPlan"
              onBlur={handleBlur}
              type="date"
              value={
                values.endAfter != null
                  ? getStandardDate(values.endAfter)
                  : ""
              }
              onChange={handleChange("endAfter")}
              name="endAfter"
              min={NewDateString()}
              disabled={true}
            />
          </div>
         
        </div>
            </div>
                     
            
            ) : ("")}
             <div className="row m-0">
             <div className="col-sm-6">
          <div className= "cv-input-field-container-disabled">
            <label htmlFor="RegulatoryPlan" className="cv-input-label">
              Regulatory/ Standard Requirements<span className="asterisk-required">*</span>
            </label>
            <input
              id="RegulatoryPlan"
              className="cv-input-field leftPadding"
              onBlur={handleBlur}
              type="input"
              value={values.regulatory}
              onChange={handleChange("regulatory")}
              name="regulatory"
              placeholder={"Please enter Regulatory/ Standard Requirements"}
              disabled={true}
            />
          </div>
          {errors.regulatory && touched.regulatory && (
            <div className="form-label error">{errors.regulatory}</div>
          )}
        </div>
</div>
        </div>
    );
}
AssessmentPlan.propTypes = {
    values: PropTypes.any, 
    touched: PropTypes.any, 
    errors: PropTypes.any, 
    handleChange: PropTypes.any, 
    handleBlur: PropTypes.any, 
    getAssessorMail: PropTypes.any, 
    getManagerMail: PropTypes.any,
    getAssessment: PropTypes.any,
    role: PropTypes.any,
    vendors: PropTypes.any,
    criticality: PropTypes.any,
    frequency: PropTypes.any,
    recurrence: PropTypes.any,
    Classification: PropTypes.any,
    assessmentTypes: PropTypes.any,
    Assessors: PropTypes.any,
    Managers: PropTypes.any
}
export default AssessmentPlan